<template>
  <div class="ibox">
    <div class="ibox-title"><h5>菜单管理</h5></div>
    <div class="ibox-content">
    <div class="crud-bar">
      <el-button type="primary" icon="el-icon-plus" @click="openCreate(null)">新建顶级菜单</el-button>
    </div>
    <el-table :data="tree" v-loading="loading" border stripe row-key="id" default-expand-all :tree-props="{ children: 'children' }">
      <el-table-column prop="title" label="标题" />
      <el-table-column prop="icon" label="图标" width="90" />
      <el-table-column prop="type" label="类型" width="90" />
      <el-table-column prop="uri" label="URI" />
      <el-table-column prop="order" label="排序" width="70" />
      <el-table-column label="操作" width="220">
        <template slot-scope="s">
          <el-button size="mini" @click="openCreate(s.row)">加子项</el-button>
          <el-button size="mini" @click="openEdit(s.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="onDelete(s.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="440px">
      <el-form :model="form" label-width="80px">
        <el-form-item label="父级">
          <el-select v-model="form.pid" placeholder="顶级菜单" clearable>
            <el-option v-for="m in flatMenus" :key="m.id" :label="m.title" :value="m.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="标题"><el-input v-model="form.title" /></el-form-item>
        <el-form-item label="图标"><el-input v-model="form.icon" placeholder="el-icon-*" /></el-form-item>
        <el-form-item label="类型"><el-input v-model="form.type" placeholder="menu / action" /></el-form-item>
        <el-form-item label="URI"><el-input v-model="form.uri" /></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="form.order" :min="0" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="onSave">保存</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { menusApi } from '../api/admin'

function buildTree (list, pid = 0) {
  return list
    .filter(m => (m.pid || 0) === pid)
    .sort((a, b) => (a.order || 0) - (b.order || 0))
    .map(m => {
      const children = buildTree(list, m.id)
      return children.length ? { ...m, children } : { ...m }
    })
}

export default {
  name: 'AdminMenus',
  data () {
    return {
      list: [],
      tree: [],
      flatMenus: [],
      loading: false,
      dialogVisible: false,
      saving: false,
      editing: null,
      form: { pid: null, title: '', icon: '', type: '', uri: '', order: 0 }
    }
  },
  computed: { dialogTitle () { return this.editing ? '编辑菜单' : '新建菜单' } },
  created () { this.fetch() },
  methods: {
    async fetch () {
      this.loading = true
      try {
        this.list = await menusApi.list()
        this.flatMenus = this.list
        this.tree = buildTree(this.list)
      } catch (e) { this.$message.error(e.uiMessage || e.message) } finally { this.loading = false }
    },
    openCreate (parent) {
      this.editing = null
      this.form = { pid: parent ? parent.id : null, title: '', icon: '', type: 'menu', uri: '', order: 0 }
      this.dialogVisible = true
    },
    openEdit (row) { this.editing = row; this.form = { ...row }; this.dialogVisible = true },
    async onSave () {
      if (!this.form.title) return this.$message.warning('请填写标题')
      const payload = { ...this.form }
      if (payload.pid === '') payload.pid = null
      this.saving = true
      try {
        if (this.editing) await menusApi.update(this.editing.id, payload)
        else await menusApi.create(payload)
        this.$message.success('已保存'); this.dialogVisible = false; this.fetch()
      } catch (e) { this.$message.error(e.uiMessage || e.message) } finally { this.saving = false }
    },
    async onDelete (row) {
      if (!await this.$confirm(`确认删除菜单「${row.title}」？`, '提示', { type: 'warning' }).catch(() => false)) return
      try { await menusApi.remove(row.id); this.$message.success('已删除'); this.fetch() } catch (e) { this.$message.error(e.uiMessage || e.message) }
    }
  }
}
</script>

<style scoped>
.crud-bar { margin-bottom: 16px; }
</style>
